import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.background[100]};
    border-radius: 1.25rem;
    padding: 1.5rem;
    border: 1px solid ${theme.colors.base.border};
    box-shadow: ${theme.shadows.sm};
    margin-bottom: 1rem;
    max-width: 1280px;
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
`;

export const HeaderTitle = styled.h3`
  ${({ theme }) => css`
    font-size: 1rem;
    font-weight: 700;
    color: ${theme.colors.foreground[100]};
    display: flex;
    align-items: center;
    gap: 0.5rem;
  `}
`;

export const CountBadge = styled.span`
  ${({ theme }) => css`
    font-size: 0.75rem;
    font-weight: 600;
    color: ${theme.colors.foreground[40]};
    background: ${theme.colors.background[80]};
    padding: 0.125rem 0.625rem;
    border-radius: 9999px;
  `}
`;

export const SortButton = styled.button`
  ${({ theme }) => css`
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${theme.colors.brand.primary.default};
    background: none;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.25rem;

    svg {
      width: 0.875rem;
      height: 0.875rem;
    }
  `}
`;

export const InputDivider = styled.div`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.base.border};
    margin-bottom: 1rem;
  `}
`;

export const CommentList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const LoadMoreButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    width: 100%;
    padding: 0.875rem 0 0;
    margin-top: 0.5rem;
    border: none;
    border-top: 1px solid ${theme.colors.base.border};
    background: transparent;
    cursor: pointer;
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${theme.colors.brand.primary.default};
    transition: color ${theme.transition.default};

    svg {
      width: 1rem;
      height: 1rem;
    }

    :hover {
      color: ${theme.colors.brand.primary.hover};
    }
  `}
`;
